module.exports = "/_next/static/images/4ba64516fcd2ca2176c41091282c4a05-man-looking-up-smiling-lg@3x.jpg.webp";